import {mapState} from "vuex";
import {MOBILE_WINDOW_WIDTH} from "@/params";

export default {
    methods: {
        handleClick(event, paths = []) {
            if (this.isActive(paths)) {
                event.preventDefault();
            }
        }
    },
    computed: {
        ...mapState({
            path: state => state.sidebar.path,
            windowWidth: state => state.sidebar.windowWidth
        }),
        isActive() {
            return paths => paths.includes(this.path);
        },
        mainUrl() {
            return location.origin.replace(/^(https?:\/\/)[^./]+?\./i, '$1');
        },
        isMobile: vm => vm.windowWidth === 0 ? undefined : vm.windowWidth < MOBILE_WINDOW_WIDTH
    },
}
